import { ResponseError } from "../generated/api";

export function isResponseError(err: unknown): err is ResponseError {
  return (err as ResponseError)?.name === "ResponseError";
}
